import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CirrusButtonComponent } from './cirrus-button.component';

@NgModule({
  imports: [CommonModule],
  exports: [CirrusButtonComponent],
  declarations: [CirrusButtonComponent]
})
export class CirrusButtonModule {}
